<template>
  <div class="field-input-radio">
    <div class="input-group">
      <div class="btn-group btn-group-toggle" data-toggle="buttons">
        <div v-for="(item, i) in fieldData.values[0].radio_images.primary" :key="i">
          <label
          v-bind:class="{'btn': true,
          'active': (fieldData.field_value === item.internal_value)}"
          :for="fieldData.field_name + '_radio_option_' + i">
            <img :src="item.item_thumbnail" class="radio-thumbnail" />
          </label>
            <input
            type="radio"
            v-model="fieldData.field_value"
            :value="item.internal_value"
            :name="fieldData.field_name"
            :id="fieldData.field_name + '_radio_option_' + i"
            autocomplete="off" />
            <span>{{ item.display_value }}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  inject: ['$validator'], // Allows this component's validation messages to appear in other components
  props: ['fieldData', 'inputType'],
};
</script>

<style scoped>
/*
  TODO: Add IE/Edge support by implementing the `label.btn` styles via JavaScript. Bootstrap adds classes
  'focus' and 'active' to the radio <input>'s "closest" element, which happens to be the <label>.
  See https://github.com/twbs/bootstrap/blob/7c7a1706c348fcb5290a63d9249e0c8e4b6ebbcf/js/src/button.js#L153 .
*/
label.btn:focus-within {
  color: #fff;
  background-color: #001a33;
  border-color: #001326;
  z-index: 1;
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  -webkit-box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
  box-shadow: 0 0 0 0.2rem rgba(0, 51, 102, 0.5);
}
img.radio-thumbnail {
  width: 3rem;
  border-radius: 50%;
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/interactive/InputRadioImages.vue?5e548a50